import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function WhyMatters() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="why-matters">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-8">
                        The Oversight Gap Is Where Most VA Relationships Fall Apart.
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>
                            You hire someone. The first few weeks feel promising. Then you get busy, stop checking in, and three months later you realize half the work isn't getting done the way you expected. Sound familiar?
                        </p>
                        <p>
                            The problem isn't the VA. It's the absence of a system that catches drift before it becomes a problem. Most business owners don't have time to review time logs, cross-reference task lists, and coach a remote worker every week. That's exactly what we do for you.
                        </p>
                        <p>
                            Every month, we pull your VA's timeclock data, review it line by line, and send you a structured summary. No jargon. No dashboards you'll never look at. Just a clear picture of how your VA is spending their time and whether it matches what you're paying for.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
